import { React, useState} from "react";
import { Outlet, Link } from "react-router-dom";

//styles
import './styles/index.scss';
// import "primereact/resources/themes/saga-orange/theme.css"

// Bootstrap JS is required for some functionality
import "bootstrap/dist/js/bootstrap.bundle.min";

//pages
import { Ripple } from 'primereact/ripple';


function getSessionStorageOrDefault(key, defaultValue) {
    const stored =  sessionStorage.getItem(key);
    if (!stored) {
      return defaultValue;
    }
    return JSON.parse(stored);

  }

  console.log('we on workflows');

function Workflows() {

    // eslint-disable-next-line no-unused-vars
    const [userDetails, setUserDetails] = useState(
        getSessionStorageOrDefault('userDetails', null)
    );

    const canViewconfig = (userDetails) => {
        if (userDetails) {
            return userDetails.permissions.some(e => e.codename === 'view_workflowconfigmanagement');
        }
        return false;
    }

    const found_view_workflow = userDetails?.permissions.find(permission => permission.codename === 'view_workflows') || false;
    
    return (
        <>
            { found_view_workflow === false && <h1 className="h1 m-5"> You do not have permission to view the workflows module.</h1> }
            { found_view_workflow &&
            <div className="container-fluid">
                <div className="row">
                    <div className="surface-section h-screen border-right-1 surface-border flex flex-column w-18rem select-none">
                        <div className="overflow-y-auto">
                            <ul className="list-none p-2 m-0">
                                <li>
                                    <Link to='' className="p-ripple flex align-items-center cursor-pointer p-3 text-700 hover:surface-100 border-round transition-colors transition-duration-150 w-full text-decoration-none">
                                        <i className="pi pi-list mr-2"></i>
                                        <span className="font-medium">Dashboard</span>
                                        <Ripple />
                                    </Link>
                                </li>
                                <li>
                                    <Link to='select' className="p-ripple flex align-items-center cursor-pointer p-3 text-700 hover:surface-100 border-round transition-colors transition-duration-150 w-full text-decoration-none">
                                        <i className="pi pi-plus-circle mr-2"></i>
                                        <span className="font-medium">New Workflow</span>
                                        <Ripple />
                                    </Link>
                                </li>
                                { canViewconfig(userDetails) && 
                                    <li>
                                        <Link to='config' className="p-ripple flex align-items-center cursor-pointer p-3 text-700 hover:surface-100 border-round transition-colors transition-duration-150 w-full text-decoration-none">
                                            <i className="pi pi-cog mr-2"></i>
                                            <span className="font-medium">Config</span>
                                            <Ripple />
                                        </Link>
                                    </li>
                                }
                            </ul>
                        </div>
                    </div>
                    <div className="col ms-sm-auto px-md-4 container-fluid">
                        <Outlet />
                    </div>
                </div>
            </div>
            }
        </>
    );
}

export default Workflows;